import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({

  selector: 'siat-field-divider',
  templateUrl: './field-divider.component.html',
  imports: [CommonModule, TranslatePipe],
})
export class FieldDividerComponent implements OnInit {
  @Input() title!: string;
  translatedTitle = '';

  private translateService = inject(TranslateService);

  ngOnInit(): void {
    // Aggiunge un controllo per verificare se la chiave esiste
    if (this.title && this.translateService.instant(this.title) !== this.title) {
      this.translatedTitle = this.translateService.instant(this.title);
    } else {
      this.translatedTitle = this.title;
    }
  }
}
